import React from 'react';

const ProductSidebar = () => {
  return (
    <div className="w-full md:w-1/4 float-left px-6 min-h-[1px]">
      <section className="relative">
        <div>
          <h2 className="hidden">PRODUCTS</h2>
          <div>
            <div className="flex flex-col hidden-xs">
              <div className="col-md-12 mb-[10px]">
                <a href="https://cao.com.vn/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/PNJweb_Home_HinhSpDaiDien_Cao.jpg"
                    title="CAO" 
                    style={{width: '100%'}}
                    alt="CAO"
                  />
                </a>
              </div>
              <div className="col-md-12 mb-[10px]">
                <a href="https://www.pnj.com.vn/trang-suc-kim-cuong/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/PNJweb_Home_HinhSpDaiDien_KC.jpg" 
                    title="Trang sức kim cương" 
                    style={{width: '100%'}}
                    alt="Trang sức kim cương"
                  />
                </a>
              </div>
              <div className="col-md-12 mb-[10px]">
                <a href="https://www.pnj.com.vn/trang-suc-da-quy/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/PNJweb_Home_HinhSpDaiDien_DaMau.jpg" 
                    title="Trang sức đá quý" 
                    style={{width: '100%'}}
                    alt="Trang sức đá quý"
                  />
                </a>
              </div>
              <div className="col-md-12 mb-[10px]">
                <a href="https://www.pnj.com.vn/trang-suc-cuoi/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/PNJweb_Home_HinhSpDaiDien_Cuoi.png" 
                    title="Trang sức cưới" 
                    style={{width: '100%'}}
                    alt="Trang sức cưới"
                  />
                </a>
              </div>
              <div className="col-md-12 mb-[10px]">
                <a href="https://www.pnj.com.vn/trang-suc-vang/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/PNJweb_Home_HinhSpDaiDien_Vang.png" 
                    title="Trang sức vàng" 
                    style={{width: '100%'}}
                    alt="Trang sức vàng"
                  />
                </a>
              </div>
              <div className="col-md-12 mb-[10px]">
                <a href="https://www.pnj.com.vn/qt-doanh-nghiep/">
                  <img 
                    className="lazy-loaded" 
                    src="https://cdn.pnj.io/images/gold-price/quatangdoanhnghiep.png" 
                    title="Quà tặng doanh nghiệp" 
                    style={{width: '100%'}}
                    alt="Quà tặng doanh nghiệp"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductSidebar;